export const FRAUD_TIMEZONES = [
  'Asia/Shanghai', // Most common identifier for China
  'Asia/Beijing', // Alternative China identifier
  'Asia/Hong_Kong', // Hong Kong
  'Asia/Macau', // Macau
  'Asia/Taipei', // Taiwan (if applicable to your business)
  'Asia/Pyongyang', // North Korea
  'Europe/Moscow',
  'Asia/Singapore', // Singapore - blocked due to scraper activity
];

export const FRAUD_LOCALES = [
  'zn',
  'zh-CN', // Simplified Chinese (China mainland)
  'zh-TW', // Traditional Chinese (Taiwan)
  'zh-HK', // Traditional Chinese (Hong Kong)
  'zh-MO', // Traditional Chinese (Macau)
  'zh-SG', // Chinese (Singapore)
  'zh-MY', // Chinese (Malaysia)
];
